/* eslint-disable max-lines */
import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const UsIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_8605_25168)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 0.00195312H35.9983V1.84738H0.00732422V0.00195312Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 3.69336H35.9983V5.53867H0.00732422V3.69336Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 7.38281H35.9983V9.22824H0.00732422V7.38281Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 11.0742H35.9983V12.9195H0.00732422V11.0742Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 14.7656H35.9983V16.611H0.00732422V14.7656Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 18.4551H35.9983V20.3005H0.00732422V18.4551Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 22.1465H35.9983V23.9919H0.00732422V22.1465Z"
        fill="#CC0101"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00732422 0.00195312H15.5167V12.9198H0.00732422V0.00195312Z"
        fill="#002767"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06335 0.607422L1.20464 0.946361L1.55057 0.984933L1.29199 1.23301L1.36449 1.59575L1.06335 1.41016L0.762243 1.59575L0.834752 1.23301L0.576172 0.984933L0.922093 0.946361L1.06335 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73816 0.607422L2.87945 0.946361L3.22537 0.984933L2.96679 1.23301L3.03926 1.59575L2.73816 1.41016L2.43705 1.59575L2.50956 1.23301L2.25098 0.984933L2.59686 0.946361L2.73816 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.41296 0.607422L4.55425 0.946361L4.90017 0.984933L4.64159 1.23301L4.71407 1.59575L4.41296 1.41016L4.11185 1.59575L4.18436 1.23301L3.92578 0.984933L4.27167 0.946361L4.41296 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08776 0.607422L6.22906 0.946361L6.57498 0.984933L6.31636 1.23301L6.38887 1.59575L6.08776 1.41016L5.78666 1.59575L5.85917 1.23301L5.60059 0.984933L5.94647 0.946361L6.08776 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76212 0.607422L7.90341 0.946361L8.24933 0.984933L7.99072 1.23301L8.06322 1.59575L7.76212 1.41016L7.46101 1.59575L7.53352 1.23301L7.2749 0.984933L7.62082 0.946361L7.76212 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43692 0.607422L9.57821 0.946361L9.92417 0.984933L9.66556 1.23301L9.73799 1.59575L9.43692 1.41016L9.13578 1.59575L9.20829 1.23301L8.94971 0.984933L9.29566 0.946361L9.43692 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1117 0.607422L11.253 0.946361L11.5989 0.984933L11.3404 1.23301L11.4128 1.59575L11.1117 1.41016L10.8106 1.59575L10.8831 1.23301L10.6245 0.984933L10.9705 0.946361L11.1117 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7861 0.607422L12.9273 0.946361L13.2733 0.984933L13.0147 1.23301L13.0872 1.59575L12.7861 1.41016L12.485 1.59575L12.5574 1.23301L12.2988 0.984933L12.6448 0.946361L12.7861 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4609 0.607422L14.6021 0.946361L14.9481 0.984933L14.6895 1.23301L14.762 1.59575L14.4609 1.41016L14.1598 1.59575L14.2322 1.23301L13.9736 0.984933L14.3196 0.946361L14.4609 0.607422Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.90079 2.39453L2.04208 2.73347L2.38797 2.77204L2.12939 3.02012L2.2019 3.38282L1.90079 3.19724L1.59968 3.38282L1.67219 3.02012L1.41357 2.77204L1.7595 2.73347L1.90079 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.57559 2.39453L3.71689 2.73347L4.06277 2.77204L3.80419 3.02012L3.8767 3.38282L3.57559 3.19724L3.27448 3.38282L3.34699 3.02012L3.08838 2.77204L3.4343 2.73347L3.57559 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2504 2.39453L5.39169 2.73347L5.73758 2.77204L5.479 3.02012L5.55151 3.38282L5.2504 3.19724L4.94929 3.38282L5.0218 3.02012L4.76318 2.77204L5.1091 2.73347L5.2504 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92471 2.39453L7.06597 2.73347L7.41189 2.77204L7.15331 3.02012L7.22582 3.38282L6.92471 3.19724L6.62361 3.38282L6.69608 3.02012L6.4375 2.77204L6.78342 2.73347L6.92471 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59948 2.39453L8.74078 2.73347L9.08666 2.77204L8.82812 3.02012L8.90063 3.38282L8.59948 3.19724L8.29841 3.38282L8.37088 3.02012L8.1123 2.77204L8.45823 2.73347L8.59948 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2744 2.39453L10.4156 2.73347L10.7616 2.77204L10.503 3.02012L10.5754 3.38282L10.2744 3.19724L9.97318 3.38282L10.0457 3.02012L9.78711 2.77204L10.1331 2.73347L10.2744 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9491 2.39453L12.0904 2.73347L12.4364 2.77204L12.1778 3.02012L12.2502 3.38282L11.9491 3.19724L11.6481 3.38282L11.7205 3.02012L11.4619 2.77204L11.8079 2.73347L11.9491 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6234 2.39453L13.7647 2.73347L14.1107 2.77204L13.8521 3.02012L13.9245 3.38282L13.6234 3.19724L13.3224 3.38282L13.3948 3.02012L13.1362 2.77204L13.4822 2.73347L13.6234 2.39453Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06335 4.17969L1.20464 4.51863L1.55057 4.5572L1.29199 4.80524L1.36449 5.16798L1.06335 4.98239L0.762243 5.16798L0.834752 4.80524L0.576172 4.5572L0.922093 4.51863L1.06335 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73816 4.17969L2.87945 4.51863L3.22537 4.5572L2.96679 4.80524L3.03926 5.16798L2.73816 4.98239L2.43705 5.16798L2.50956 4.80524L2.25098 4.5572L2.59686 4.51863L2.73816 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.41296 4.17969L4.55425 4.51863L4.90017 4.5572L4.64159 4.80524L4.71407 5.16798L4.41296 4.98239L4.11185 5.16798L4.18436 4.80524L3.92578 4.5572L4.27167 4.51863L4.41296 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08776 4.17969L6.22906 4.51863L6.57498 4.5572L6.31636 4.80524L6.38887 5.16798L6.08776 4.98239L5.78666 5.16798L5.85917 4.80524L5.60059 4.5572L5.94647 4.51863L6.08776 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76212 4.17969L7.90341 4.51863L8.24933 4.5572L7.99072 4.80524L8.06322 5.16798L7.76212 4.98239L7.46101 5.16798L7.53352 4.80524L7.2749 4.5572L7.62082 4.51863L7.76212 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43692 4.17969L9.57821 4.51863L9.92417 4.5572L9.66556 4.80524L9.73799 5.16798L9.43692 4.98239L9.13578 5.16798L9.20829 4.80524L8.94971 4.5572L9.29566 4.51863L9.43692 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1117 4.17969L11.253 4.51863L11.5989 4.5572L11.3404 4.80524L11.4128 5.16798L11.1117 4.98239L10.8106 5.16798L10.8831 4.80524L10.6245 4.5572L10.9705 4.51863L11.1117 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7861 4.17969L12.9273 4.51863L13.2733 4.5572L13.0147 4.80524L13.0872 5.16798L12.7861 4.98239L12.485 5.16798L12.5574 4.80524L12.2988 4.5572L12.6448 4.51863L12.7861 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4609 4.17969L14.6021 4.51863L14.9481 4.5572L14.6895 4.80524L14.762 5.16798L14.4609 4.98239L14.1598 5.16798L14.2322 4.80524L13.9736 4.5572L14.3196 4.51863L14.4609 4.17969Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.90079 5.9668L2.04208 6.30574L2.38797 6.34431L2.12939 6.59238L2.2019 6.95513L1.90079 6.76954L1.59968 6.95513L1.67219 6.59238L1.41357 6.34431L1.7595 6.30574L1.90079 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.57559 5.9668L3.71689 6.30574L4.06277 6.34431L3.80419 6.59238L3.8767 6.95513L3.57559 6.76954L3.27448 6.95513L3.34699 6.59238L3.08838 6.34431L3.4343 6.30574L3.57559 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2504 5.9668L5.39169 6.30574L5.73758 6.34431L5.479 6.59238L5.55151 6.95513L5.2504 6.76954L4.94929 6.95513L5.0218 6.59238L4.76318 6.34431L5.1091 6.30574L5.2504 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92471 5.9668L7.06597 6.30574L7.41189 6.34431L7.15331 6.59238L7.22582 6.95513L6.92471 6.76954L6.62361 6.95513L6.69608 6.59238L6.4375 6.34431L6.78342 6.30574L6.92471 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59948 5.9668L8.74078 6.30574L9.08666 6.34431L8.82812 6.59238L8.90063 6.95513L8.59948 6.76954L8.29841 6.95513L8.37088 6.59238L8.1123 6.34431L8.45823 6.30574L8.59948 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2744 5.9668L10.4156 6.30574L10.7616 6.34431L10.503 6.59238L10.5754 6.95513L10.2744 6.76954L9.97318 6.95513L10.0457 6.59238L9.78711 6.34431L10.1331 6.30574L10.2744 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9491 5.9668L12.0904 6.30574L12.4364 6.34431L12.1778 6.59238L12.2502 6.95513L11.9491 6.76954L11.6481 6.95513L11.7205 6.59238L11.4619 6.34431L11.8079 6.30574L11.9491 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6234 5.9668L13.7647 6.30574L14.1107 6.34431L13.8521 6.59238L13.9245 6.95513L13.6234 6.76954L13.3224 6.95513L13.3948 6.59238L13.1362 6.34431L13.4822 6.30574L13.6234 5.9668Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06335 7.75195L1.20464 8.09089L1.55057 8.12946L1.29199 8.37754L1.36449 8.74028L1.06335 8.55469L0.762243 8.74028L0.834752 8.37754L0.576172 8.12946L0.922093 8.09089L1.06335 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73816 7.75195L2.87945 8.09089L3.22537 8.12946L2.96679 8.37754L3.03926 8.74028L2.73816 8.55469L2.43705 8.74028L2.50956 8.37754L2.25098 8.12946L2.59686 8.09089L2.73816 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.41296 7.75195L4.55425 8.09089L4.90017 8.12946L4.64159 8.37754L4.71407 8.74028L4.41296 8.55469L4.11185 8.74028L4.18436 8.37754L3.92578 8.12946L4.27167 8.09089L4.41296 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08776 7.75195L6.22906 8.09089L6.57498 8.12946L6.31636 8.37754L6.38887 8.74028L6.08776 8.55469L5.78666 8.74028L5.85917 8.37754L5.60059 8.12946L5.94647 8.09089L6.08776 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76212 7.75195L7.90341 8.09089L8.24933 8.12946L7.99072 8.37754L8.06322 8.74028L7.76212 8.55469L7.46101 8.74028L7.53352 8.37754L7.2749 8.12946L7.62082 8.09089L7.76212 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43692 7.75195L9.57821 8.09089L9.92417 8.12946L9.66556 8.37754L9.73799 8.74028L9.43692 8.55469L9.13578 8.74028L9.20829 8.37754L8.94971 8.12946L9.29566 8.09089L9.43692 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1117 7.75195L11.253 8.09089L11.5989 8.12946L11.3404 8.37754L11.4128 8.74028L11.1117 8.55469L10.8106 8.74028L10.8831 8.37754L10.6245 8.12946L10.9705 8.09089L11.1117 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7861 7.75195L12.9273 8.09089L13.2733 8.12946L13.0147 8.37754L13.0872 8.74028L12.7861 8.55469L12.485 8.74028L12.5574 8.37754L12.2988 8.12946L12.6448 8.09089L12.7861 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4609 7.75195L14.6021 8.09089L14.9481 8.12946L14.6895 8.37754L14.762 8.74028L14.4609 8.55469L14.1598 8.74028L14.2322 8.37754L13.9736 8.12946L14.3196 8.09089L14.4609 7.75195Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.90079 9.53906L2.04208 9.878L2.38797 9.91657L2.12939 10.1646L2.2019 10.5275L1.90079 10.3418L1.59968 10.5275L1.67219 10.1646L1.41357 9.91657L1.7595 9.878L1.90079 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.57559 9.53906L3.71689 9.878L4.06277 9.91657L3.80419 10.1646L3.8767 10.5275L3.57559 10.3418L3.27448 10.5275L3.34699 10.1646L3.08838 9.91657L3.4343 9.878L3.57559 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2504 9.53906L5.39169 9.878L5.73758 9.91657L5.479 10.1646L5.55151 10.5275L5.2504 10.3418L4.94929 10.5275L5.0218 10.1646L4.76318 9.91657L5.1091 9.878L5.2504 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.92471 9.53906L7.06597 9.878L7.41189 9.91657L7.15331 10.1646L7.22582 10.5275L6.92471 10.3418L6.62361 10.5275L6.69608 10.1646L6.4375 9.91657L6.78342 9.878L6.92471 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59948 9.53906L8.74078 9.878L9.08666 9.91657L8.82812 10.1646L8.90063 10.5275L8.59948 10.3418L8.29841 10.5275L8.37088 10.1646L8.1123 9.91657L8.45823 9.878L8.59948 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2744 9.53906L10.4156 9.878L10.7616 9.91657L10.503 10.1646L10.5754 10.5275L10.2744 10.3418L9.97318 10.5275L10.0457 10.1646L9.78711 9.91657L10.1331 9.878L10.2744 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9491 9.53906L12.0904 9.878L12.4364 9.91657L12.1778 10.1646L12.2502 10.5275L11.9491 10.3418L11.6481 10.5275L11.7205 10.1646L11.4619 9.91657L11.8079 9.878L11.9491 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6234 9.53906L13.7647 9.878L14.1107 9.91657L13.8521 10.1646L13.9245 10.5275L13.6234 10.3418L13.3224 10.5275L13.3948 10.1646L13.1362 9.91657L13.4822 9.878L13.6234 9.53906Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06335 11.3242L1.20464 11.6632L1.55057 11.7017L1.29199 11.9498L1.36449 12.3126L1.06335 12.1269L0.762243 12.3126L0.834752 11.9498L0.576172 11.7017L0.922093 11.6632L1.06335 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73816 11.3242L2.87945 11.6632L3.22537 11.7017L2.96679 11.9498L3.03926 12.3126L2.73816 12.1269L2.43705 12.3126L2.50956 11.9498L2.25098 11.7017L2.59686 11.6632L2.73816 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.41296 11.3242L4.55425 11.6632L4.90017 11.7017L4.64159 11.9498L4.71407 12.3126L4.41296 12.1269L4.11185 12.3126L4.18436 11.9498L3.92578 11.7017L4.27167 11.6632L4.41296 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.08776 11.3242L6.22906 11.6632L6.57498 11.7017L6.31636 11.9498L6.38887 12.3126L6.08776 12.1269L5.78666 12.3126L5.85917 11.9498L5.60059 11.7017L5.94647 11.6632L6.08776 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76212 11.3242L7.90341 11.6632L8.24933 11.7017L7.99072 11.9498L8.06322 12.3126L7.76212 12.1269L7.46101 12.3126L7.53352 11.9498L7.2749 11.7017L7.62082 11.6632L7.76212 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.43692 11.3242L9.57821 11.6632L9.92417 11.7017L9.66556 11.9498L9.73799 12.3126L9.43692 12.1269L9.13578 12.3126L9.20829 11.9498L8.94971 11.7017L9.29566 11.6632L9.43692 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1117 11.3242L11.253 11.6632L11.5989 11.7017L11.3404 11.9498L11.4128 12.3126L11.1117 12.1269L10.8106 12.3126L10.8831 11.9498L10.6245 11.7017L10.9705 11.6632L11.1117 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7861 11.3242L12.9273 11.6632L13.2733 11.7017L13.0147 11.9498L13.0872 12.3126L12.7861 12.1269L12.485 12.3126L12.5574 11.9498L12.2988 11.7017L12.6448 11.6632L12.7861 11.3242Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4609 11.3242L14.6021 11.6632L14.9481 11.7017L14.6895 11.9498L14.762 12.3126L14.4609 12.1269L14.1598 12.3126L14.2322 11.9498L13.9736 11.7017L14.3196 11.6632L14.4609 11.3242Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8605_25168">
        <rect width="36" height="24" fill="white" />
      </clipPath>
    </defs>
  </ChakraIcon>
);
